// Services
import ApiServiceV2 from 'services/apiService/apiServiceV2';

const endpoint = '/services';
const useServiceApi = () => {
	return {
		/**
		 * Get departments, order targets and services
		 * @returns {Object[]} Array of service objects
		 */

		getServices: () => {
			return ApiServiceV2.get({
				url: `${endpoint}/v1/departmentsOrderTargetsAndServices`,
			});
		},
	};
};

export default useServiceApi;
